module.exports = __webpack_public_path__ + "8d9a3349b9f548ff16fd6e5527b08fd6.png";